// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Asset_Asset__3wx2o {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 20px;
    color: rgba(129, 102, 21, 0.99);
    color: #747686;
    font-style: italic;
  }

  .Asset_Asset2__ULXob {
    align-items: center;
    min-height: 20px;
    /* color: rgba(129, 102, 21, 0.99); */
    color: #747686;
  }

  .Asset_Asset3__-qnMr {
    align-items: center;
    min-height: 20px;
    color: #747686;
    font-style: italic;
  }

  .Asset_Asset__3wx2o:hover {
    cursor: pointer;
  }

  .Asset_Asset2__ULXob:hover {
    cursor: pointer;
  }

  .Asset_Asset3__-qnMr:hover {
    cursor: pointer;
    color: #000;
  }`, "",{"version":3,"sources":["webpack://./src/styles/Asset.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb","sourcesContent":[".Asset {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 20px;\n    color: rgba(129, 102, 21, 0.99);\n    color: #747686;\n    font-style: italic;\n  }\n\n  .Asset2 {\n    align-items: center;\n    min-height: 20px;\n    /* color: rgba(129, 102, 21, 0.99); */\n    color: #747686;\n  }\n\n  .Asset3 {\n    align-items: center;\n    min-height: 20px;\n    color: #747686;\n    font-style: italic;\n  }\n\n  .Asset:hover {\n    cursor: pointer;\n  }\n\n  .Asset2:hover {\n    cursor: pointer;\n  }\n\n  .Asset3:hover {\n    cursor: pointer;\n    color: #000;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Asset": `Asset_Asset__3wx2o`,
	"Asset2": `Asset_Asset2__ULXob`,
	"Asset3": `Asset_Asset3__-qnMr`
};
export default ___CSS_LOADER_EXPORT___;
